import { ELEMENT_AI_CONTENT } from '@sketchnote/slate-plugins';
import { ELEMENT_DEFAULT, insertNodes, PlateEditor, TEditor } from '@udecode/plate';
import { BaseElement, Editor, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

export const useAddNewBlockAtEnd = (editor: TEditor & ReactEditor & PlateEditor) => {
  return () => {
    ReactEditor.focus(editor);
    const elem = editor.children[editor.children.length - 1] as BaseElement;
    if (elem) {
      const isEmpty = Editor.isEmpty(editor, elem);
      const isAIElement = (elem as any)?.type === ELEMENT_AI_CONTENT;
      if (!isEmpty || isAIElement) {
        const insertPath = Editor.end(editor, []);
        insertNodes(
          editor,
          { type: ELEMENT_DEFAULT, children: [{ text: '' }] },
          { at: [insertPath.path[0] + 1] }
        );
        Transforms.select(editor, [editor.children.length - 1]);
      } else {
        Transforms.select(editor, Editor.end(editor, []));
      }
    }
  };
};
